import { FormControl, FormControlLabel, FormLabel, InputAdornment, Radio, RadioGroup } from "@mui/material";
import { FieldProps } from "@rjsf/core";
import { IconPremium } from "./IconPremium";
import './styles/radio.scss'

export const RadioPremium = (props: FieldProps) => {

    const { title: label, enum: list } = props.schema
    const { disabled, inline } = (props.uiSchema['ui:options'] || {}) as Record<string, any>

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        props.onChange(e.currentTarget.value)
    }

    return (
        <FormControl component="fieldset" className="control-radio-premium">
            <FormLabel component="legend">
                { label }
            </FormLabel>

            {
                disabled &&
                <InputAdornment position="end">
                    <IconPremium />
                </InputAdornment>
            }
            <RadioGroup
                row={inline}
                id={props.idSchema.$id}
                onChange={handleChange}>
                {
                    list?.map((item, index) => (
                        <FormControlLabel
                            key={index} 
                            value={item} 
                            disabled={disabled !== false}
                            control={<Radio />} 
                            label={item?.toLocaleString() || ''} />
                    ))
                }
            </RadioGroup>
            
        </FormControl>
    )
}
